<div class="most-popular-items-component">
  <ion-toolbar mode="md" color="dark">
    <ion-title>{{ 'posManager.mostPopularItems' | transloco }} </ion-title>
    <ion-buttons slot="end">
      <ion-button
        mode="md"
        debounce-click
        [debounceTime]="0"
        (debounceClick)="onBack()"
        >{{ 'common.close' | transloco }}</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
  <div class="meal-selector-wrapper">
    <div class="date-container text-wrap">
      {{ currentLocation?.name || ('posManager.location' | transloco) }}
      <span>
        <fa-icon
          [icon]="faCircle"
          style="font-size: 6px; vertical-align: middle"></fa-icon
      ></span>
      {{ date | translocoDate: { weekday: 'long', month: 'short', day: 'numeric' } }}
    </div>
    <div class="meal-selector-container">
      <ion-segment [value]="selectedMealId" mode="md">
        <ion-segment-button
          [value]="MealTime.Breakfast"
          (click)="onMealChangeHandler(MealTime.Breakfast)">
          <ion-label>{{ 'meals.breakfast' | transloco }}</ion-label>
        </ion-segment-button>
        <ion-segment-button
          [value]="MealTime.Lunch"
          (click)="onMealChangeHandler(MealTime.Lunch)">
          <ion-label>{{ 'meals.lunch' | transloco }}</ion-label>
        </ion-segment-button>
        <ion-segment-button
          [value]="MealTime.Dinner"
          (click)="onMealChangeHandler(MealTime.Dinner)">
          <ion-label>{{ 'meals.dinner' | transloco }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
  </div>

  <div class="component-content">
    <div class="popular-items-list">
      <div
        *ngIf="mostPopularItems.length > 0; else noItems"
        class="items-container">
        <div
          *ngFor="let item of mostPopularItems; let i = index"
          class="popular-item">
          <div class="item-rank">{{ i + 1 }}.</div>
          <div class="item-details">
            <div class="item-name">{{ item | translatedName: currentLang }}</div>
          </div>
          <div class="item-count">{{ item.order_count }}</div>
        </div>
      </div>

      <ng-template #noItems>
        <div class="no-items">
          <p>{{ 'posManager.noPopularItemsDataAvailable' | transloco }}</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
